module.exports = function getBytesRemaining(fileProgress) {
  return fileProgress.bytesTotal - fileProgress.bytesUploaded;
};


//////////////////
// WEBPACK FOOTER
// ./~/@uppy/utils/lib/getBytesRemaining.js
// module id = 358
// module chunks = 0